import React, { useState, useEffect} from 'react';
import { isAuthenticated } from "../../store/action/auth";
import {Accordion, Card} from "react-bootstrap";
import {updateUserCourier, updateUserOnLocal} from "../../store/action/user";
import {getCouriers} from "../../store/action/courier";
import Freshchat from "../../components/atoms/FreshChat";


const CourierSetting = () => {
    const { user, token } = isAuthenticated();
    const [ couriers, setCouriers ] = useState([]);
    const [ userCouriers, setUserCouriers ] = useState([]);
    const [ loading, setLoading ] = useState(true);

    useEffect(() => {
        _fetchData()
    }, []);

    const _fetchData = async () => {
        try {
            const cou = await getCouriers(token);
            if (cou.success) {
                setCouriers(cou.couriers);
            } else {
                alert(cou.error)
            }
            setLoading(false);
            setUserCouriers(user.couriers)
        } catch (e) {
            console.log (e);
            alert("Gagal ambil data akun. Mohon ulangi kembali.")
        }
    };

    if (loading) {
        return (
            <div className="p-4">
                <p>Loading...</p>
            </div>
        )
    }


    const updateCourier = async (i) => {
        const service = `${i.courierCode}_${i.courierServiceCode}`;
        const res = await updateUserCourier(token,service);
        if (res.success) {
            let data = {
                ...user,
                organization:{
                    name: user.organizationName,
                    bankAccounts:user.bankAccounts,
                },
                couriers:res.couriers
            };
            updateUserOnLocal(data,()=>{
                setUserCouriers(res.couriers)
            });
        } else {
            alert(res.error)
        }
    };

    return (
        <div className="p-4 flex-column">
            <h6>Atur kurir yang ingin diaktifkan</h6>
            <Accordion>
                {
                    couriers.map((i,idx) => {
                        if (idx === couriers.length-1) {
                                return (
                                    <Card key={idx} className="">
                                        <Card className="p-0 border-0">
                                            <Accordion.Toggle className="p-0 border-bottom-0" as={Card.Header} variant="link" eventKey={idx}>
                                                <h6>{i.courierName}</h6>
                                            </Accordion.Toggle>
                                        </Card>
                                        <Accordion.Collapse eventKey={idx}>
                                            <Card.Body className={"p-0"}>
                                                {
                                                    couriers.map((j,jdx) => {
                                                        if(j.courierName === i.courierName) {
                                                            return (
                                                                <Card key={jdx}>
                                                                    <div className="row justify-content-between px-4">
                                                                        <div>
                                                                            <h6 className="mb-0">{j.courierServiceName}</h6>
                                                                            <p className="mb-0">{j.description} ({j.shipmentDurationRange} {j.shipmentDurationUnit})</p>
                                                                        </div>
                                                                        <div className="custom-control custom-switch">
                                                                            <input
                                                                                onChange={() => updateCourier ( j )}
                                                                                type="checkbox"
                                                                                className="custom-control-input "
                                                                                checked={userCouriers.includes(j.courierCode) || userCouriers.includes(`${j.courierCode}_${j.courierServiceCode}`)}
                                                                                id={jdx}/>
                                                                            <label className="custom-control-label" htmlFor={jdx}></label>
                                                                        </div>
                                                                    </div>
                                                                </Card>

                                                            )
                                                        }
                                                    })
                                                }
                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                )
                        }

                        if (i.courierName !== couriers[idx+1].courierName) {
                            return (
                                <Card key={idx} className="">
                                    <Card className="p-0 border-0 pointer">
                                        <Accordion.Toggle className="p-0 border-bottom-0" as={Card.Header} variant="link" eventKey={idx}>
                                            <h6>{i.courierName}</h6>
                                        </Accordion.Toggle>
                                    </Card>
                                    <Accordion.Collapse eventKey={idx}>
                                        <Card.Body className={"p-0"}>
                                        {
                                            couriers.map((j,jdx) => {
                                                if(j.courierName === i.courierName) {
                                                    return (
                                                        <Card key={jdx} >
                                                            <div key={idx} className="row justify-content-between px-4">
                                                                <div>
                                                                    <h6 className="mb-0">{j.courierServiceName}</h6>
                                                                    <p className="mb-0">{j.description} ({j.shipmentDurationRange} {j.shipmentDurationUnit})</p>
                                                                </div>
                                                                <div className="custom-control custom-switch">
                                                                    <input
                                                                        onChange={() => updateCourier (j)}
                                                                        type="checkbox"
                                                                        className="custom-control-input"
                                                                        checked={userCouriers.includes(j.courierCode) || userCouriers.includes(`${j.courierCode}_${j.courierServiceCode}`)}
                                                                        id={jdx}/>
                                                                    <label className="custom-control-label pointer" htmlFor={jdx}></label>
                                                                </div>
                                                            </div>
                                                        </Card>
                                                    )
                                                }
                                            })
                                        }
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                            )
                        }
                    })
                }
            </Accordion>
        </div>
    )
};

export default CourierSetting;
